export function firebaseLoader({ src, width, quality }: { src: string; width: number; quality?: number }) {
  // If the URL is already a Firebase Storage URL, return it as is
  if (src.startsWith("https://storage.googleapis.com/")) {
    return src;
  }

  // Otherwise, construct the Firebase Storage URL
  const bucket = process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET;
  return `https://storage.googleapis.com/${bucket}/${src}`;
}
